import type { InjectionKey } from 'vue';
import type { BlockEditorContext } from '#layers/block-engine/types/block-editor';
import { inject } from 'vue';

export const blockEditorContextKey = Symbol('blockEditorContext') as InjectionKey<BlockEditorContext>;

export function useBlockEditorContext(): BlockEditorContext {
	const context = inject(blockEditorContextKey, null);

	if (!context) {
		throw new Error('useBlockEditorContext() is called outside of block editor context');
	}

	return context;
}
